<!-- Menu Part -->
<nav class="navbar navbar-expand-lg navbar-light bg-light sticky-top">
	<div class="container">
		<a class="navbar-brand" href="#"><img src="assets/images/ILMS-Logo.png" alt="ILMS"></a>
		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
			aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse" id="navbarNav">
			<ul class="nav navbar-nav ml-auto">
				<li class="nav-item">
					<a class="nav-link" routerLink="/">Home</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" routerLink="/product">Features</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" routerLink="/pricing">Pricing</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" routerLink="/contact">Contact Us</a>
				</li>
			   <!--  <li class="nav-item">
					<a class="nav-link" routerLink="/clients">Clients</a>
				</li> -->
			</ul>
		</div>
	</div>
</nav>
